module.exports = __webpack_public_path__ + "img/use_case_discorver.afd131ed.png";